/* eslint-disable no-tabs */
import { COMPANY_PROFILE_DEFAULT } from 'components/icons/constants';
import PropTypes from 'prop-types';

const HeadQuarterIcon = ({
    color = COMPANY_PROFILE_DEFAULT.color,
    size = COMPANY_PROFILE_DEFAULT.size
}) => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={size}
        height={size}
        viewBox="0 0 70.865 70.867"
        enableBackground="new 0 0 70.865 70.867"
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M58.627,12.24c-3.013-3.012-6.521-5.376-10.427-7.029C44.157,3.5,39.86,2.634,35.434,2.634
		c-4.429,0-8.725,0.866-12.769,2.577C18.76,6.864,15.252,9.229,12.24,12.24c-3.012,3.013-5.377,6.521-7.03,10.426
		c-1.71,4.045-2.578,8.34-2.578,12.767c0,4.428,0.868,8.724,2.578,12.771c1.653,3.904,4.018,7.411,7.03,10.423
		c3.012,3.011,6.52,5.379,10.425,7.028c4.044,1.714,8.34,2.58,12.769,2.58c4.426,0,8.723-0.866,12.767-2.58
		c3.906-1.649,7.414-4.018,10.427-7.028c3.012-3.012,5.375-6.519,7.028-10.423c1.711-4.047,2.579-8.343,2.579-12.771
		c0-4.427-0.867-8.722-2.579-12.767C64.003,18.761,61.639,15.253,58.627,12.24z M35.434,66.289
		c-17.015,0-30.857-13.84-30.857-30.856c0-17.013,13.842-30.855,30.857-30.855c17.013,0,30.856,13.843,30.856,30.855
		C66.29,52.449,52.447,66.289,35.434,66.289z"
            />
            <path
                fill={color}
                d="M46.587,16.847C43.66,14.301,39.958,12.9,36.165,12.9h-0.091H35.97c-1.647,0-3.228,0.243-4.701,0.724
		c-3.796,1.239-7.028,3.813-9.097,7.247c-2.068,3.432-2.839,7.499-2.171,11.447c0.359,2.136,1.053,4.068,2.063,5.75
		c0.519,0.865,1.09,1.699,1.641,2.511c0.426,0.623,0.864,1.267,1.269,1.909c2.5,3.965,5.027,8.007,7.471,11.918l1.645,2.63
		c0.493,0.788,1.213,1.243,1.975,1.243c0.761,0,1.474-0.452,1.955-1.236c0.086-0.143,0.172-0.286,0.258-0.428
		c0.182-0.303,0.371-0.614,0.561-0.914c0.789-1.243,1.578-2.488,2.367-3.732c2.679-4.226,5.448-8.596,8.192-12.88
		c0.677-1.059,1.438-2.334,1.955-3.79c0.999-2.812,1.239-5.763,0.715-8.768C51.415,22.791,49.469,19.351,46.587,16.847z
		M49.52,34.649c-0.45,1.27-1.143,2.427-1.76,3.392c-2.747,4.286-5.518,8.659-8.198,12.887c-0.789,1.247-1.578,2.488-2.367,3.735
		c-0.201,0.313-0.394,0.637-0.582,0.945c-0.085,0.142-0.169,0.28-0.254,0.418c-0.148,0.246-0.273,0.306-0.296,0.309
		c-0.025-0.003-0.163-0.063-0.328-0.327l-1.644-2.631c-2.446-3.913-4.972-7.956-7.475-11.926c-0.422-0.672-0.872-1.329-1.306-1.969
		c-0.537-0.785-1.091-1.6-1.581-2.414c-0.883-1.473-1.496-3.179-1.813-5.074c-1.212-7.172,3.068-14.275,9.954-16.521
		c1.277-0.417,2.655-0.628,4.098-0.628h0.098c0.004,0,0.008,0,0.013,0h0.085c6.78,0,12.793,5.166,13.986,12.019
		C50.617,29.536,50.405,32.155,49.52,34.649z"
            />
            <path
                fill={color}
                d="M43.669,25.836l-4.663-0.679l-2.084-4.224c-0.164-0.332-0.502-0.541-0.872-0.541
		c-0.369,0-0.707,0.209-0.871,0.541l-2.084,4.224l-4.663,0.679c-0.366,0.053-0.67,0.309-0.785,0.66
		c-0.114,0.353-0.018,0.74,0.246,0.996l3.374,3.29l-0.795,4.644c-0.063,0.363,0.086,0.732,0.386,0.95
		c0.169,0.122,0.37,0.187,0.571,0.187c0.155,0,0.31-0.039,0.452-0.113l4.17-2.191l4.17,2.191c0.144,0.074,0.298,0.113,0.455,0.113
		c0.537-0.004,0.971-0.438,0.971-0.973c0-0.076-0.009-0.151-0.025-0.222l-0.787-4.586l3.375-3.29
		c0.265-0.256,0.36-0.644,0.245-0.996C44.34,26.145,44.035,25.889,43.669,25.836z M39.112,29.745
		c-0.229,0.225-0.333,0.546-0.279,0.86l0.55,3.206l-2.88-1.512c-0.283-0.149-0.621-0.149-0.904,0l-2.879,1.512l0.55-3.206
		c0.054-0.314-0.05-0.636-0.281-0.86l-2.329-2.271l3.22-0.467c0.316-0.047,0.59-0.245,0.731-0.531l1.439-2.918l1.44,2.918
		c0.142,0.286,0.416,0.484,0.732,0.531l3.219,0.467L39.112,29.745z"
            />
        </g>
    </svg>
);

HeadQuarterIcon.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default HeadQuarterIcon;
